import Vue from 'vue'
import VCurrencyField from 'v-currency-field'
import i18n from '@/plugins/i18n'

Vue.use(VCurrencyField, {
  locale: i18n.t('app_info.locale'),
  decimalLength: 2,
  autoDecimalMode: true,
  min: null,
  max: null,
  defaultValue: 0,
  valueAsInteger: true,
  allowNegative: false
})



// WEBPACK FOOTER //
// ./src/plugins/v-currency-field.js